import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";
import { Grid, Tab, Button } from "semantic-ui-react";
import GET_ENGAGEMENT_DETAILS from "../queries/EngagementDetailsQuery";
import GiraffeLoader from "./GiraffeLoader";
import ServerError from "./ServerError";

export const AgencyStatementOfWork = ({ selectedOnboardingToken }) => {
  const { data, loading, error } = useQuery(GET_ENGAGEMENT_DETAILS, {
    variables: { onboarding_token: selectedOnboardingToken },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <GiraffeLoader />;
  }

  if (error) {
    return <ServerError />;
  }

  const { engagementDetails } = data;

  return (
    <Tab.Pane>
      <div className="py-16 border-b border-neutral-20">
        <Grid>
          <Grid.Row columns={3}>
            <Grid.Column width={8}>
              <b>Name</b>
            </Grid.Column>
            <Grid.Column width={2}>
              <p>Status</p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
      <div className="py-16 border-b border-neutral-20">
        <Grid>
          <Grid.Row columns={3}>
            <Grid.Column width={8}>
              <b>Statement of work</b>
            </Grid.Column>
            <Grid.Column width={2}>
              {engagementDetails?.value ? (
                <Button
                  as="a"
                  href={engagementDetails.value}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                  primary
                >
                  Download
                </Button>
              ) : (
                <p>No Document Available</p>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </Tab.Pane>
  );
};

AgencyStatementOfWork.propTypes = {
  selectedOnboardingToken: PropTypes.string.isRequired,
};
